module.exports = __webpack_public_path__ + "static/media/Portrait-10234.7bb7044f.jpg";